module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [(_vm.hasfactura) ? _c('div') : (!_vm.hasfactura) ? _c('v-card', {
    staticClass: "factura",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 80) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.impresion($event)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('h4', {
    staticClass: "warning--text existencia"
  }, [_vm._v(" Existencia: " + _vm._s(_vm.producto.existencia))]), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "print",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": "",
      "disabled": _vm.validatefactura
    },
    on: {
      "click": function($event) {
        return _vm.focusbusqueda()
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("search")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "buscador ma-0 pa-0",
    attrs: {
      "fluid": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "precio",
      "disabled": ""
    },
    model: {
      value: (_vm.precio),
      callback: function($$v) {
        _vm.precio = $$v
      },
      expression: "precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "singleLine": "",
      "label": "producto",
      "disabled": ""
    },
    model: {
      value: (_vm.producto.producto),
      callback: function($$v) {
        _vm.$set(_vm.producto, "producto", $$v)
      },
      expression: "producto.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm1": ""
    }
  }, [_c('v-text-field', {
    ref: "cantidad",
    attrs: {
      "type": "number",
      "singleLine": "",
      "label": "cantidad",
      "min": "1"
    },
    on: {
      "change": function($event) {
        return _vm.checklista()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardarventa($event)
      }
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presentacion),
      expression: "presentacion"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.presentacion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.presentaciones), function(press) {
    return _c('option', {
      domProps: {
        "value": press
      }
    }, [_vm._v("\n                " + _vm._s(press.presentacion) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "select xs6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listado),
      expression: "listado"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checklista]
    }
  }, _vm._l((_vm.producto.listaprecios), function(lista) {
    return _c('option', {
      domProps: {
        "value": lista
      }
    }, [_vm._v("\n                " + _vm._s(lista.lista.nombre) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('v-flex', {
    staticClass: "justify-center",
    attrs: {
      "hidden-md-and-up": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.guardarventa
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("save")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Datos Factura")])]), _vm._v(" "), _c('v-card-text', [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.message_error) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Efectivo",
      "autofocus": "true"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardardatosfactura($event)
      }
    },
    model: {
      value: (_vm.efectivo),
      callback: function($$v) {
        _vm.efectivo = $$v
      },
      expression: "efectivo"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "primary--text"
  }, [_vm._v("Cambio: Q." + _vm._s(_vm.cambio))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardardatosfactura($event)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Escribir Observación")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cambiarcomentario($event)
      }
    },
    model: {
      value: (_vm.factura.observaciones),
      callback: function($$v) {
        _vm.$set(_vm.factura, "observaciones", $$v)
      },
      expression: "factura.observaciones"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.cambiarcomentario
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.messagemotivo),
      callback: function($$v) {
        _vm.messagemotivo = $$v
      },
      expression: "messagemotivo"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo por el que no compro")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('label', {
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.factura.observacionesmotivo),
      expression: "factura.observacionesmotivo"
    }],
    attrs: {
      "id": "motivo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.factura, "observacionesmotivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.cambiarcomentariomotivo]
    }
  }, _vm._l((_vm.motivos), function(motivo) {
    return _c('option', {
      domProps: {
        "value": motivo
      }
    }, [_vm._v("\n                " + _vm._s(motivo) + "\n              ")])
  }), 0)])])], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.cambiarcomentariomotivo
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Vendedor: " + _vm._s(_vm.factura.usuario.username))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210466c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buscador.vue
// module id = 430
// module chunks = 1